module.exports = __webpack_public_path__ + "media/assets/icons/kasai_icon2022-4dec104ff151afa3083dba5ff5f8a48e.svg";